import React from 'react';
import { Icon } from '../Icon';
import styles from './ProductSlideContentV17.css';

const BENEFITS = [
    { icon: 'bookOpenOutline', title: 'Reread anytime', text: 'Your life, in your own words.' },
    { icon: 'heartOutline', title: 'Share with loved ones', text: 'Send one story, or talk it over at the holidays.' },
    { icon: 'micOutline', title: 'Just ask', text: 'Type “that summer at the lake,” and AI finds the story.' },
    { icon: 'infinity', title: 'Keep adding', text: 'Today’s moments belong in your book too.' }
];

function ProductSlideContentV17() {
    return (
        <section className={styles.form}>
            <h2 className={styles.heading}>What you can do with your stories</h2>
            <p className={styles.description}>Your book isn’t finished on day one. It grows with you.</p>
            <ul className={styles.benefits}>
                {BENEFITS.map(benefit => (
                    <li key={benefit.title} className={styles.benefit}>
                        <Icon name={benefit.icon} className={styles.icon} />
                        <div className={styles.copy}>
                            <p className={styles.title}>{benefit.title}</p>
                            <p className={styles.text}>{benefit.text}</p>
                        </div>
                    </li>
                ))}
            </ul>
        </section>
    );
}

export {
    ProductSlideContentV17
};
